import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Fragment, isValidElement } from "react";
export const withValidation = (WrappedComponent) => {
    const componentName = WrappedComponent.displayName || WrappedComponent.name;
    const WithValidation = (props) => {
        const { children, disabled, content } = props;
        if (!isValidElement(children) || (isValidElement(children) && children.type === Fragment)) {
            console.error(`Invalid child element: ${componentName}`, children);
            return _jsx(_Fragment, { children: children });
        }
        if (disabled || typeof content === "undefined" || content === null) {
            return _jsx(_Fragment, { children: children });
        }
        return _jsx(WrappedComponent, { ...props });
    };
    WithValidation.displayName = `withValidation(${componentName})`;
    return WithValidation;
};
